import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Typography } from 'antd';
import { Input as MobileInput, Button as MobileButton } from 'antd-mobile';
import { UserOutlined, TeamOutlined, ArrowRightOutlined } from '@ant-design/icons';
import StepProgress from '../../components/StepProgress/StepProgress';
import { useUser } from '../../context/UserContext';
import { useIsMobile } from '../../hooks/useMediaQuery';
import styles from './Home.module.css';

const { Title, Text } = Typography;

export default function HomePage() {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const { profile, setProfile } = useUser();
  const [form] = Form.useForm();
  const [name, setName] = useState(profile.name);
  const [department, setDepartment] = useState(profile.department);

  const goApply = (values) => {
    setProfile(values);
    navigate('/apply');
  };

  const handleMobileSubmit = () => {
    const n = name.trim();
    const d = department.trim();
    if (!n || !d) return;
    goApply({ name: n, department: d });
  };

  const mobileReady = name.trim() && department.trim();

  if (isMobile) {
    return (
      <section className="card">
        <StepProgress current={1} />
        <div className={styles.mobileHeader}>
          <Title level={4} className={styles.mobileTitle}>填写个人信息</Title>
          <Text className={styles.mobileDesc}>
            请准确填写姓名与部门，以便为您安排合身的福利工装
          </Text>
        </div>

        <div className={styles.formFields}>
          <div className="form-item">
            <span className="form-label"><UserOutlined /> 姓名</span>
            <MobileInput placeholder="请输入姓名" value={name} onChange={setName} clearable />
          </div>
          <div className="form-item">
            <span className="form-label"><TeamOutlined /> 部门</span>
            <MobileInput placeholder="请输入部门" value={department} onChange={setDepartment} clearable />
          </div>
        </div>

        <MobileButton
          block
          color="primary"
          size="large"
          onClick={handleMobileSubmit}
          disabled={!mobileReady}
          className={styles.ctaBtn}
        >
          下一步 · 选择尺码
        </MobileButton>
      </section>
    );
  }

  return (
    <section className="card">
      <StepProgress current={1} />
      <div className={styles.hero}>
        <div className={styles.heroIntro}>
          <Title level={2} className={styles.title}>欢迎申领企业工装福利</Title>
          <Text className={styles.desc}>
            请填写基本信息后， 选择合身的工装尺码。
          </Text>
        </div>

        <div className={styles.formPanel}>
          <Form
            form={form}
            layout="vertical"
            onFinish={goApply}
            initialValues={{
              name: profile.name,
              department: profile.department,
            }}
            requiredMark={false}
          >
            <Form.Item label="姓名" name="name" rules={[{ required: true, message: '请输入姓名' }]}>
              <Input prefix={<UserOutlined />} placeholder="请输入姓名" size="large" />
            </Form.Item>
            <Form.Item label="部门" name="department" rules={[{ required: true, message: '请输入部门' }]}>
              <Input prefix={<TeamOutlined />} placeholder="请输入部门" size="large" />
            </Form.Item>
            <Form.Item style={{ marginBottom: 0 }}>
              <Button type="primary" htmlType="submit" size="large" block icon={<ArrowRightOutlined />} iconPosition="end">
                下一步 · 选择尺码
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </section>
  );
}
